// extracted by mini-css-extract-plugin
module.exports = {"wallet":"wallet_wallet__1-iZJ","address":"wallet_address__15_VS"};